/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComparisonState } from './ComparisonState';
export type PublicCompsState = {
  id?: number | null;
  gpc_comparison: Array<ComparisonState>;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  is_evaluating_equity_value?: boolean;
  first_non_forward_selected_multiple?: string | null;
  second_non_forward_selected_multiple?: string | null;
  first_forward_selected_multiple?: string | null;
  second_forward_selected_multiple?: string | null;
  first_non_forward_weighting?: string | null;
  second_non_forward_weighting?: string | null;
  first_forward_weighting?: string | null;
  second_forward_weighting?: string | null;
  first_non_forward_selection?: PublicCompsState.first_non_forward_selection;
  second_non_forward_selection?: PublicCompsState.second_non_forward_selection;
  first_forward_selection?: PublicCompsState.first_forward_selection;
  second_forward_selection?: PublicCompsState.second_forward_selection;
  weighted_enterprise_value?: string | null;
  weighted_equity_value?: string | null;
  ltm_financial_statement_period_id?: number | null;
  ntm_financial_statement_period_id?: number | null;
  percentile_selection_a?: number;
  percentile_selection_b?: number;
  use_adjusted_LTM_ebitda?: boolean;
  use_adjusted_NTM_ebitda?: boolean;
  use_multiple_premium_discount?: boolean;
  use_forward_multiple_discount?: boolean;
  first_non_forward_multiple_premium_discount?: string | null;
  second_non_forward_multiple_premium_discount?: string | null;
  first_forward_multiple_premium_discount?: string | null;
  second_forward_multiple_premium_discount?: string | null;
  multiple_basis?: PublicCompsState.multiple_basis;
  first_period_ebitda_selection?: PublicCompsState.first_period_ebitda_selection;
  second_period_ebitda_selection?: PublicCompsState.second_period_ebitda_selection;
  one_year_volatility_percentile_selection?: PublicCompsState.one_year_volatility_percentile_selection;
  two_year_volatility_percentile_selection?: PublicCompsState.two_year_volatility_percentile_selection;
  five_year_volatility_percentile_selection?: PublicCompsState.five_year_volatility_percentile_selection;
  one_year_volatility?: string | null;
  two_year_volatility?: string | null;
  five_year_volatility?: string | null;
  readonly last_refresh_date?: string;
  valuation_approach: number;
  first_period_selection?: number | null;
  second_period_selection?: number | null;
  first_period_forward_selection?: number | null;
  second_period_forward_selection?: number | null;
};
export namespace PublicCompsState {
  export enum first_non_forward_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum second_non_forward_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum first_forward_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum second_forward_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum multiple_basis {
    '_0' = 0,
    '_1' = 1,
  }
  export enum first_period_ebitda_selection {
    '_0' = 0,
    '_1' = 1,
  }
  export enum second_period_ebitda_selection {
    '_0' = 0,
    '_1' = 1,
  }
  export enum one_year_volatility_percentile_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum two_year_volatility_percentile_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
  export enum five_year_volatility_percentile_selection {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
}

